import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
// import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";
import { useProfile } from "../Components/Hooks/UserHooks";
import { logoutUser } from "../slices/auth/login/thunk";

const AuthProtected = (props : any) =>{
    const dispatch : any = useDispatch();
    const { userProfile, loading, token } = useProfile();

    useEffect(() => {
        if (!loading && (!userProfile || !token)) {
            dispatch(logoutUser());
        }
    }, [loading, userProfile, token, dispatch]);

    /*
      Navigate is un-auth access protected routes via url
      */
    if (loading) {
        return (
            <div className="d-flex justify-content-center mx-2 mt-4">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!userProfile || !token) {
        return (
            <Navigate to={{ pathname: "/login"}} replace />
        );
    }

    return <>{props.children}</>;
};


export default AuthProtected;
